export const logRequestsTableColumns = [
  { label: "Data e hora", value: "created_at", className: "w-24" },
  { label: "Ação", value: "operation_description" },
  { label: "Resultado", value: "success" },
  { label: "Ações", value: "actions", className: "w-9" },
];
